module.exports = __webpack_public_path__ + "img/icon-close.3684c22e.svg";